export default __webpack_public_path__ + "static/media/family-album.2a337116.png";